export const DEVICE_IPAD = 'ipad'
export const DEVICE_IPHONE = 'iphone';
export const DEVICE_ANDROID = 'android';

export default class MobileDetector {

    constructor() {
        this.is_mobile = false;
        this.device_type = null;
    }


    __hasDeviceTouchScreen() {
        let hasTouchScreen = false;

        if ("maxTouchPoints" in navigator) {
            hasTouchScreen = navigator.maxTouchPoints > 0;
        } else if ("msMaxTouchPoints" in navigator) {
            hasTouchScreen = navigator.msMaxTouchPoints > 0;
        } else {
            const mQ = matchMedia?.("(pointer:coarse)");
            if (mQ?.media === "(pointer:coarse)") {
                hasTouchScreen = !!mQ.matches;
            } else if ("orientation" in window) {
                hasTouchScreen = true; // deprecated, but good fallback
            }
        }

        return hasTouchScreen;
    }


    __isMobileDeviceUserAgent() {
        const userAgent = navigator.userAgent;

        if (/\b(iPhone|iPod)\b/i.test(userAgent)) {
            // console.debug('iPhone detected via user agent');
            this.__setIPhone();
        } else if (/\b(BlackBerry|webOS|IEMobile|Windows Phone)\b/i.test(userAgent)) {
            this.is_mobile = true;
            this.device_type = null;
            // console.debug('mobile device detected via user agent');

        } else if (/\b(Android)\b/i.test(userAgent)) {
            this.__setAndroid()
            // console.debug('android device detected via user agent');
        } else if (/\b(iPad)\b/i.test(userAgent)) {
            this.__setIPad();
            // console.debug('iPad device detected via user agent');
        }
        return this.is_mobile;
    }

    /**
     * Detect if the device using windows operating system or not
     * ref: https://learn.microsoft.com/en-us/microsoft-edge/web-platform/how-to-detect-win11
     * Firefox and IE11 is not supported
     */
    //TODO: use userAgentData to get more than windows platform information such as mac, android, iphone and ipad
    async __isWindowsMachine() {

        //for chrome
        if (navigator.userAgentData !== undefined) {
            await navigator.userAgentData.getHighEntropyValues(["platformVersion"])

            if (navigator.userAgentData.platform === "Windows") {
                // console.debug('windows via platform')
                this.__setWindows();
                return true;
            } else {
                return false;
            }

            // for firefox
        } else if (navigator.userAgent !== undefined) {
            let userAgent = navigator.userAgent
            if (userAgent.toLowerCase().includes('windows')) {
                // console.debug('windows via userAgent')
                this.__setWindows();
                return true;
            }
        }
        return false;
    }


    /**
     * To check IPad Device, we would like to set up device
     * @returns {boolean}
     */


    __isIPadDevice() {
        const iPadResolutions = [
            {width: 744, height: 1133, model: "iPad Mini (6th gen)"},
            {
                width: 768,
                height: 1024,
                model: "iPad Mini (5th, 4th, 3rd, 2nd, 1st), iPad (6th, 5th, 4th, 3rd, 2nd, 1st), Pro 9.7\", Air (1st, 2nd)"
            },
            {width: 810, height: 1180, model: "iPad (9th, 8th, 7th)"},
            {width: 820, height: 1180, model: "iPad Air 11\" (M3, M2, 5th, 4th), iPad (10th gen)"},
            {width: 834, height: 1210, model: "iPad Pro 11\" (M4)"},
            {width: 834, height: 1112, model: "iPad Air (3rd), iPad Pro 10.5\""},
            {width: 834, height: 1194, model: "iPad Pro 11\" (4th, 3rd, 2nd, 1st)"},
            {
                width: 1024,
                height: 1366,
                model: "iPad Air 13\" (M3, M2), iPad Pro 12.9\" (6th, 5th, 4th, 3rd, 2nd, 1st)"
            },
            {width: 1032, height: 1376, model: "iPad Pro 13\" (M4)"},
        ];

        const monitorWidth = screen.width;
        const monitorHeight = screen.height;
        // console.debug("monitor_width: %s, monitor_height %s", monitorWidth, monitorHeight);

        let isIPad = false;
        let detectedModel = null;

        for (const resolution of iPadResolutions) {
            if (monitorWidth === resolution.width && monitorHeight === resolution.height) {
                this.__setIPad();
                isIPad = true;
                detectedModel = resolution.model;
                break; // Exit the loop once a match is found
            }
        }

        const result = this.device_type === DEVICE_IPAD ? true : false;
        // console.debug('iPad device detected via screen resolution: ' + result + (detectedModel ? ` (${detectedModel})` : ''));
        return result;
    }


    __setIPad() {
        this.is_mobile = true;
        this.device_type = DEVICE_IPAD //iPad Air 11" (m3,  M2,5th, 4th), iPAD(A16, 10th)
    }

    __setIPhone() {
        this.is_mobile = true;
        this.device_type = DEVICE_IPHONE //iPad Air 11" (m3,  M2,5th, 4th), iPAD(A16, 10th)
    }

    __setAndroid() {
        this.is_mobile = true;
        this.device_type = DEVICE_ANDROID //iPad Air 11" (m3,  M2,5th, 4th), iPAD(A16, 10th)
    }

    __setWindows() {
        this.is_mobile = false;
        this.device_type = null;
    }

    __detectPcScreenResolution() {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;

        let deviceType = "Unknown";
        let deviceTypeList = ["Standard PC", "Laptop/PC", "PC"]

        // Common standard PC and Laptop resolutions (non-exhaustive)
        const standardResolutions = [
            {width: 640, height: 480, type: "Standard PC"},   // VGA
            {width: 800, height: 600, type: "Standard PC"},   // SVGA
            {width: 1024, height: 768, type: "Standard PC"},  // XGA
            {width: 1280, height: 720, type: "Laptop/PC"},    // HD (720p)
            {width: 1280, height: 800, type: "Laptop"},
            {width: 1366, height: 768, type: "Laptop"},
            {width: 1440, height: 900, type: "Laptop"},
            {width: 1600, height: 900, type: "Laptop/PC"},
            {width: 1920, height: 1080, type: "Laptop/PC"},   // Full HD (1080p)
            {width: 2560, height: 1440, type: "PC"},          // QHD (1440p)
            {width: 3440, height: 1440, type: "PC"},          // UWQHD
            {width: 3840, height: 2160, type: "PC"},          // 4K UHD
        ];

        for (const resolution of standardResolutions) {
            if (screenWidth === resolution.width && screenHeight === resolution.height) {
                deviceType = resolution.type;
                break;
            }
        }

        // console.debug(`Screen Width: ${screenWidth}px`);
        // console.debug(`Screen Height: ${screenHeight}px`);
        // console.debug(`Detected Device Type: ${deviceType}`);
        return deviceTypeList.includes(deviceType);
    }


    async detect() {
        /**
         * Most of mobile devices has touch screen.
         * The first step of screening process is to check weather the device has touch screen.
         * Then we check the device user agent (which still risky) that the client are in android, ipad,Iphone from the user agent.
         * if not we check user agent with windows machine or not
         * then check with iPad using screen resolution.
         * None of passed then we set as android.
         *
         *
         * ** The potential risk is: if someone has touch screen with PC and use inspector to manipulate the user agent,
         * we have no way to detect it for now.
         */


        // always first check the device has touch screen or not.
        // we skip this process for "development" environment for the easier development process
        if (process.env.VUE_APP_MODE !== 'development' && this.__hasDeviceTouchScreen() === false) {

            return false;
        }

        // check if mobile device has user agent
        if (this.__isMobileDeviceUserAgent()) {

            if (this.device_type === null) {
                this.__isIPadDevice() // check if this is iPad Device
            }

            return this.is_mobile;
        } else {
            let is_windows_machine= await this.__isWindowsMachine();
            if (is_windows_machine) {

                return false;

            } else if (this.__isIPadDevice()) {

                return true;

            } else {
                // If we cannot detect windows information from user agent and
                // the screen size is not iPad. We consider most of the device as mobile device.
                // We need to detect screen size to check if the device has PC/Laptop screen resolution or not
                // Pending to use this function until we found some more issues. Windows with Chrome and edge will
                // detect the touch screen. So we don't need to use this one at the moment.

                // if (this.__detectPcScreenResolution()) {
                //     return false;
                // }

                // we check device has touch screen or not if the environment is development (that is skipped from the top).
                if (process.env.VUE_APP_MODE === 'development' && this.__hasDeviceTouchScreen() === false) {
                    return false;
                }


                this.__setAndroid();
                return true;
            }
        }
    }
}